<template>
  <v-card class="elevation-4">
    <v-toolbar color="grey darken-3" dark flat>
      <v-toolbar-title>RESET PASSWORD</v-toolbar-title>
      <v-spacer />
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn icon large :to="{ name: 'login' }" v-on="on">
            <v-icon>mdi-key</v-icon>
          </v-btn>
        </template>
        <span>Login</span>
      </v-tooltip>
    </v-toolbar>
    <v-progress-linear absolute indeterminate color="accent" height="7" v-if="loading"></v-progress-linear>
    <v-card-text>
      <v-alert dense type="warning" v-if="error && error.message">{{error.message}}</v-alert>
      <p class="title text-center" v-if="!error && !reset && token">Enter your new password.</p>
      <p class="title text-center" v-if="!error && resetSent && !token">Reset email has been sent...</p>
      <p
        class="title text-center"
        v-if="!error && reset"
      >Your password has been reset! You can now login.</p>
      <v-row v-if="!token && !resetSent">
        <v-col cols="12">
          <p>Enter the email you registered with to reset your password.</p>
          <v-text-field
            label="Email"
            v-model="userEmail"
            name="email"
            prepend-icon="mdi-email"
            type="text"
            :rules="[(v) => !!v || 'Email is required']"
            required
            validate-on-blur
          />
        </v-col>
      </v-row>
      <v-row v-if="token && !reset">
        <v-col cols="12" md="6">
          <v-text-field
            label="Password"
            v-model="password"
            prepend-icon="mdi-key"
            type="password"
            :rules="[(v) => !!v || 'Password is required']"
            required
            validate-on-blur
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            label="Confirm Password"
            v-model="password_confirmation"
            type="password"
            :rules="passwordConfirmationRules"
            required
            validate-on-blur
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        class="ma-2"
        color="primary"
        outlined
        :to="{ name: 'login' }"
        v-if="!error && reset"
      >Login</v-btn>
      <v-btn
        class="ma-2"
        color
        outlined
        v-if="!token && !resetSent"
        @click="sendReset()"
      >Request Reset</v-btn>
      <v-btn class="ma-2" color outlined v-if="token && !reset" @click="resetPwd()">Reset Password</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { authManagement } from "@/api";

export default {
  data: () => ({
    loading: false,
    reset: false,
    resetSent: false,
    error: null,
    email: null,
    password: null,
    password_confirmation: null,
  }),
  created() {},
  mounted() {},
  computed: {
    token() {
      return this.$route.query.token;
    },
    userEmail: {
      get() {
        return this.email;
      },
      set(email) {
        this.email = email.toLowerCase();
      }
    },
    passwordConfirmationRules() {
      return [
        (v) => !!v || "Password confirmation is required",
        () =>
          this.password === this.password_confirmation ||
          "Password confirmation does not match password",
      ];
    },
  },
  methods: {
    resetInputs() {
      this.email = null;
      this.password = null;
      this.password_confirmation = null;
    },
    async sendReset() {
      this.loading = true;
      try {
        await authManagement.create({
          action: "sendResetPwd",
          value: { email: this.email },
        });
        this.resetSent = true;
        this.loading = false;
      } catch (error) {
        this.error = error;
        this.loading = false;
        this.resetInputs();
      }
    },
    async resetPwd() {
      if (
        this.token &&
        this.password &&
        this.password === this.password_confirmation
      ) {
        this.loading = true;
        try {
          await authManagement.create({
            action: "resetPwdLong",
            value: { token: this.token, password: this.password },
          });
          this.reset = true;
          this.loading = false;
        } catch (error) {
          this.error = error;
          this.loading = false;
          this.$router.push({ name: "reset" });
        }
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
</style>